module.exports = __webpack_public_path__ + "img/mct_logo.e9f07e3e.png";